module.exports = __webpack_public_path__ + "static/media/radiobutton_white.cdd9e309.svg";